import { render, staticRenderFns } from "./AppCamada.vue?vue&type=template&id=022a6646&lang=pug"
import script from "./AppCamada.vue?vue&type=script&lang=js"
export * from "./AppCamada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports